export default __webpack_public_path__ + "static/tyres-5b45c032a36154bba007bb2fc1374d44.png";